module.exports = __webpack_public_path__ + "img/sjfw.d3e78155.png";